export const validation = {
  privacyPolicy: "Please enter Privacy Policy",
};
